// src/components/Footer.jsx

import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.jpg";
import "../styles/footer.css";
import indiaFlag from "../assets/images/India.png";
import uaeFlag from "../assets/images/UAE.png";

const serviceSectionMap = {
  "digital-transformation": "Digital Transformation",
  "business-intelligence": "Business Intelligence",
  "analytics-data-science": "Analytics and Data Science",
  "cybersecurity": "Cybersecurity/Information Security",
  "ai-tech": "AI & Emerging Technologies",
  "customer-analytics": "Customer Analytics",
  "data-management": "Data Management Modelling and Mining",
  "innovation": "Innovation and Data Architects and Scientist",
  "it-compliance": "IT Compliance Risk and Governance",
  "intelligent-info": "Intelligent Information/RPA",
  "e-gov-iot": "E-gov/Iot/IIoT",
};

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-left">
          <img src={logo} alt="CeiTCS Logo" className="footer-logo" />

          <h3>24/7 CALL US</h3>

          <p style={{ display: "flex", alignItems: "center", gap: "8px", color: "white" }}>
            Mobile:
            <img src={indiaFlag} alt="India Flag" style={{ width: "24px" }} />
            +91 9791424421
          </p>

          <p style={{ display: "flex", alignItems: "center", gap: "8px", color: "white" }}>
            Mobile:
            <img src={uaeFlag} alt="UAE Flag" style={{ width: "24px" }} />
            +971 545313855
          </p>

          <h3>24/7 OUR LOCATION</h3>

          <p className="footerp">
            <strong>F2, Plot Number 36</strong>
          </p>

          <p className="footerp">
            Ranganathan Nagar Second Street,
          </p>

          <p className="footerp">
            Selaiyur, Tambaram, Chennai - 600073
          </p>
        </div>

        <div className="footer-middle">
          <h3>Quick Links</h3>

          <ul>
            <li className="footer-item"><Link to="/home" className="footer-link">➤ Home</Link></li>
            <li className="footer-item"><Link to="/about" className="footer-link">➤ About Us</Link></li>
            <li className="footer-item"><Link to="/features" className="footer-link">➤ Features</Link></li>
            <li className="footer-item"><Link to="/services" className="footer-link">➤ Services</Link></li>
            <li className="footer-item"><Link to="/blog" className="footer-link">➤ Blog</Link></li>
            <li className="footer-item"><Link to="/contact" className="footer-link">➤ Contact Us</Link></li>
            <li className="footer-item"><Link to="/experts" className="footer-link">➤ Experts</Link></li>
            <li className="footer-item"><Link to="/careers" className="footer-link">➤ Careers</Link></li>
            <li className="footer-item"><Link to="/feedback" className="footer-link">➤ Feedback</Link></li>
            <li className="footer-item"><Link to="/client" className="footer-link">➤ Client</Link></li>
          </ul>
        </div>

        <div className="footer-services">
          <h3>Services</h3>

          <ul>
            {Object.entries(serviceSectionMap).map(([sectionId, label]) => (
              <li key={sectionId} className="footer-service-link">
                <Link
                  to={`/services#${sectionId}`}
                  className="footer-link"
                >
                  ➤ {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-right">
  <h3>Features</h3>

  <ul>
    <li className="footer-feature-link">
      <Link to="/features#ai-cybersecurity">
        ➤ AI and Cybersecurity
      </Link>
    </li>

    <li className="footer-feature-link">
      <Link to="/features#ai-healthcare">
        ➤ AI and Healthcare
      </Link>
    </li>

    <li className="footer-feature-link">
      <Link to="/features#sap-mm">
        ➤ SAP MM
      </Link>
    </li>
  </ul>
</div>
      </div>

      <div className="footer-bottom">
        <p className="footerp">
          © Copyright 2024. All rights reserved. CeiTCS.
        </p>

        <div className="social-icons">
          <button>📘 Facebook</button>
          <button>🐦 Twitter</button>
          <button>📸 Instagram</button>
          <button>🔗 LinkedIn</button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;